module.exports = __webpack_public_path__ + "img/2.bc38cc52.jpg";